//For ZOD schema validation, we need to convert date strings to Date objects. This utility function takes a date string and returns a Date object, or null if the input is empty or invalid.

export const dateStringToDate = (val) => {
  if (typeof val === "string" || val instanceof Date) {
    return new Date(val);
  }
  return undefined;
};
